import React from 'react';
import Link from 'next/link';
import Icon from '@common/assets';
import { RouteUrl } from '@utils/routeUtil';

import RouterQuery, { UtmOrigin } from '@utils/routeUtil/RouterQuery';
import classnames from 'classnames/bind';
import styles from './preparation.module.scss';
const cx = classnames.bind(styles);

const AccaTest = () => {
  return (
    // 역검(역량검사) 영역
    <div className={cx('preparationListArea')}>
      <em className={cx('preparationTitle')}>역검(역량검사)</em>
      <ul className={cx('preparationList')}>
        <li className={cx('listItem')}>
          <Link href={RouteUrl.ACCA_TEST_LIST} legacyBehavior>
            <a className={cx('link')} target="_blank" role="button">
              <div className={cx('icon')}>
                <Icon name="acca" />
              </div>
              <div className={cx('infoArea')}>
                <div className={cx('infoTitle')}>역량검사 실전</div>
                <p className={cx('infoDesc')}>
                  역량검사를 응시하고 내 역량에 적합한
                  <br />
                  포지션을 추천받아 보세요.
                </p>
              </div>
            </a>
          </Link>
        </li>
        <li className={cx('listItem')}>
          <Link href={RouteUrl.ACCA_TUTORIAL} legacyBehavior>
            <a className={cx('link')} role="button">
              <div className={cx('icon')}>
                <Icon name="guideAccaGreen" />
              </div>
              <div className={cx('infoArea')}>
                <div className={cx('infoTitle')}>역량검사 튜토리얼</div>
                <p className={cx('infoDesc')}>
                  성향파악부터 영상면접까지,
                  <br />
                  실전과 동일한 환경에서 연습할 수 있어요.
                </p>
              </div>
            </a>
          </Link>
        </li>
        <li className={cx('listItem')}>
          <Link
            href={{ pathname: RouteUrl.ACCA_RESULTS, query: RouterQuery.getUtmSource(UtmOrigin.Preparation) }}
            legacyBehavior
          >
            <a className={cx('link')} role="button">
              <div className={cx('icon')}>
                <Icon name="testAcca" />
              </div>
              <div className={cx('infoArea')}>
                <div className={cx('infoTitle')}>역량검사 결과표</div>
                <p className={cx('infoDesc')}>
                  응시한 역량검사 결과를 가지고
                  <br />
                  취업준비에 참고 및 활용할 수 있어요.
                </p>
              </div>
            </a>
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default AccaTest;
